import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Form, Container, Row, Col, Card } from "react-bootstrap";

const AddOdhMoney = () => {
  const [formData, setFormData] = useState({
    mobileNumber: "",
    package: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSearch = (e) => {
    e.preventDefault();
    console.log("Searching for mobile number:", formData.mobileNumber);
  };

  const handleActive = () => {
    console.log("Package Activated:", formData.package);
  };

  return (
    <Container fluid className="mt-2 px-2  wt-2">
      <Row>
        <Col md={6} style={{ alignItems: "flex-start", display: "flex" }}>
          <Card
            className="shadow-lg p-4"
            style={{
              borderRadius: "12px",
              backgroundColor: "#f8f9fa",
              minWidth: "300px",
              maxWidth: "400px",
              height: "auto",
              width: "100%",
            }}
          >
            <Card.Body>
              <h4
                className="mb-4 "
                style={{ fontWeight: "600", color: "#333", textAlign: "left" }}
              >
                Add Money
              </h4>
              <Form>
                <Form.Group className="mb-3" controlId="formMobileNumber">
                  <Form.Label style={{ fontWeight: "500" }}>Mobile Number</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter mobile number"
                    name="mobileNumber"
                    value={formData.mobileNumber}
                    onChange={handleInputChange}
                    required
                    className="border-1 rounded-lg"
                    style={{
                      borderColor: "#ced4da",
                      height: "40px",
                      fontSize: "14px",
                    }}
                  />
                </Form.Group>

                <Button
                  variant="success"
                  className="py-1 mb-3"
                  onClick={handleSearch}
                  style={{
                    backgroundColor: "#28a745",
                    borderColor: "#28a745",
                    fontWeight: "500",
                    fontSize: "14px",
                    width: "80px", // Reduced button width
                  }}
                >
                  Search
                </Button>

                <Form.Group className="mb-3" controlId="formPackage">
                  <Form.Label style={{ fontWeight: "500" }}>Select Package</Form.Label>
                  <Form.Control
                    as="select"
                    name="package"
                    value={formData.package}
                    onChange={handleInputChange}
                    required
                    className="border-1 rounded-lg"
                    style={{
                      borderColor: "#ced4da",
                      height: "40px",
                      fontSize: "14px",
                      backgroundColor: "#fff",
                    }}
                  >
                    <option value="">Select Package</option>
                    <option value="1000">1000</option>
                    <option value="2000">2000</option>
                    <option value="3000">3000</option>
                  </Form.Control>
                </Form.Group>

                <Button
                  variant="primary"
                  className="py-1"
                  onClick={handleActive}
                  style={{
                    backgroundColor: "#007bff",
                    borderColor: "#007bff",
                    fontWeight: "500",
                    fontSize: "14px",
                    width: "100px", // Reduced button width
                  }}
                >
                  Activate
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AddOdhMoney;
